import React, { Component } from 'react';
import Joyride, { ACTIONS, EVENTS } from 'react-joyride';
import * as clevertapSidebarFtue from 'clevertap/sidebarFtue';
import WelcomeModal from './WelcomeModal';
import Tooltip from './Tooltip';
import CompletionModal from './CompletionModal';

const buttonLocale = {
  next: 'Lanjut',
  back: 'Kembali',
  last: 'Lanjut',
};

const defaultStep = {
  disableBeacon: true,
  placement: 'right',
  locale: buttonLocale,
  ftueOptions: {},
};

// TODO Joyride does not support multiple spotlight, so we need to find a way to do it
const steps = [
  {
    ...defaultStep,
    target: '.sidebar-nav .dashboard',
    content:
      'Lihat perkembangan bisnis atau masing-masing outlet yang Anda miliki dari waktu ke waktu dalam satu dashboard.',
    ftueOptions: {
      openSidebarItem: 'dashboard',
      trackEvent: {
        default: clevertapSidebarFtue.tourDashboard,
        next: clevertapSidebarFtue.tourDashboardNext,
        back: () => {},
      },
    },
    title: 'Rangkuman Bisnis Terintegrasi',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .reports',
    content:
      'Dapatkan laporan penjualan secara detail dalam beberapa kategori, seperti Sales, Transactions, Invoices, dan Shift.',
    ftueOptions: {
      openSidebarItem: 'reports',
      trackEvent: {
        default: clevertapSidebarFtue.tourReports,
        next: clevertapSidebarFtue.tourReportsNext,
        back: clevertapSidebarFtue.tourReportsBack,
      },
    },
    title: 'Data Penjualan Lengkap',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .library',
    content:
      'Selain mengelola daftar semua produk atau layanan yang ditawarkan, Anda juga bisa membuat promo atau diskon lewat menu ini.',
    ftueOptions: {
      openSidebarItem: 'library',
      trackEvent: {
        default: clevertapSidebarFtue.tourLibrary,
        next: clevertapSidebarFtue.tourLibraryNext,
        back: clevertapSidebarFtue.tourLibraryBack,
      },
    },
    title: 'Atur Barang Yang Dijual Dalam Library',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .inventory',
    content:
      'Dengan Inventory Management, kini Anda bisa memantau masuk-keluar inventaris, daftar pemasok, supply order yang sedang berjalan, hingga pergerakan inventaris antar cabang.',
    ftueOptions: {
      openSidebarItem: 'inventory',
      trackEvent: {
        default: clevertapSidebarFtue.tourInventory,
        next: clevertapSidebarFtue.tourInventoryNext,
        back: clevertapSidebarFtue.tourInventoryBack,
      },
    },
    title: 'Mudahnya Kelola Inventaris',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .customers',
    content:
      'Yuk, kenal lebih dekat dengan pelanggan! Anda bisa membuat database, mendapat feedback, serta menginisiasi loyalty program agar pelanggan kembali dan kembali lagi.',
    ftueOptions: {
      openSidebarItem: 'customers',
      trackEvent: {
        default: clevertapSidebarFtue.tourCustomers,
        next: clevertapSidebarFtue.tourCustomersNext,
        back: clevertapSidebarFtue.tourCustomersBack,
      },
    },
    title: 'Ketahui Siapa Pelanggan Anda',
  },
  {
    ...defaultStep,
    target:
      '.sidebar-nav .ingredient, .sidebar-nav .customers li:nth-child(3), .sidebar-nav .table.management',
    content:
      'Mau atur inventaris bisnis dengan praktis, meningkatkan efisiensi pengaturan meja dengan mudah, serta tingkatkan loyalitas pelanggan tanpa hambatan? Berlangganan fitur Modular Moka sekarang!',
    ftueOptions: {
      openSidebarItem: 'customers',
      trackEvent: {
        default: clevertapSidebarFtue.tourModularFeatures,
        next: clevertapSidebarFtue.tourModularFeaturesNext,
        back: clevertapSidebarFtue.tourModularFeaturesBack,
      },
    },
    title: 'Fitur Modular Moka',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .employees',
    content:
      'Dengan fitur ini, Anda bisa mengatur penempatan tugas setiap karyawan, serta membatasi akses keamanan dengan 4 digit kode otorisasi demi menghindari kecurangan.',
    ftueOptions: {
      openSidebarItem: 'employees',
      trackEvent: {
        default: clevertapSidebarFtue.tourEmployees,
        next: clevertapSidebarFtue.tourEmployeesNext,
        back: clevertapSidebarFtue.tourEmployeesBack,
      },
    },
    title: 'Atur Karyawan Agar Lebih Aman',
  },
  {
    ...defaultStep,
    target:
      '.sidebar-nav .apps, .sidebar-nav .capital, .sidebar-nav .moka.fresh, .sidebar-nav .moka.terminal.integration',
    content:
      'Kami membangun sebuah ekosistem bisnis yang memudahkan Anda mengintegrasikan aplikasi bisnis dengan Moka Connect, memperoleh pinjaman modal usaha melalui Moka Capital, serta mendapatkan bahan baku premium ke toko Anda.',
    ftueOptions: {
      openSidebarItem: 'apps',
      trackEvent: {
        default: clevertapSidebarFtue.tourEcosystemProducts,
        next: clevertapSidebarFtue.tourEcosystemProductsNext,
        back: clevertapSidebarFtue.tourEcosystemProductsBack,
      },
    },
    title: 'Mau Coba Produk Moka Lainnya?',
  },
  {
    ...defaultStep,
    target: '.sidebar-nav .account.settings',
    content:
      'Kelola informasi akun, informasi bisnis, serta pengaturan berlangganan di sini.',
    ftueOptions: {
      openSidebarItem: 'account settings',
      trackEvent: {
        default: clevertapSidebarFtue.tourAccountSettings,
        next: clevertapSidebarFtue.tourAccountSettingsNext,
        back: clevertapSidebarFtue.tourAccountSettingsBack,
      },
    },
    title: 'Kelola Akun Anda',
  },
  {
    ...defaultStep,
    placement: 'right-end',
    target: '.knowledge-center',
    content:
      'Kunjungi Help Center kami untuk mendapatkan tutorial penggunaan Moka lebih lanjut.',
    ftueOptions: {
      openSidebarItem: 'knowledge center',
      trackEvent: {
        default: clevertapSidebarFtue.tourKnowledgeCenter,
        next: clevertapSidebarFtue.tourKnowledgeCenterNext,
        back: clevertapSidebarFtue.tourKnowledgeCenterBack,
      },
    },
    title: 'Knowledge Center',
  },
];

/*
 * This is the component that controls the entire flow of Sidebar FTUE.
 */
class SidebarFtue extends Component {
  /*
   * WIP component.
   * Use `state` first for quick prototyping. We can always move to Redux later.
   */
  constructor(props) {
    super(props);

    this.state = {
      showWelcomeModal: true,
      isTourRunning: false,
      showCompletionModal: false,
      stepIndex: 0,
      mainKey: 0 /* Changing this key will force update the Joyride component */,
    };
  }

  handleWelcomeModalClose = () => {
    this.setState({
      showWelcomeModal: false,
      isTourRunning: true,
    });
  };

  handleJoyrideCallback = joyrideData => {
    const {
      onEnterStep,
      onEndStep,
      onTourStart,
      onTourEnd,
      onClickLanjut,
      onClickKembali,
    } = this.props;
    const { type: eventType, step, index, action } = joyrideData;
    const { mainKey } = this.state;

    switch (eventType) {
      case EVENTS.TOUR_START:
        onTourStart(step);
        break;

      case EVENTS.TOUR_END:
        onTourEnd(step);
        this.setState({
          showCompletionModal: true,
          mainKey: mainKey + 1 /* hack to reset joyride component */,
        });
        break;

      case EVENTS.STEP_BEFORE:
        onEnterStep(step);
        break;

      case EVENTS.STEP_AFTER:
        onEndStep(step);
        this.setState({
          stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
        });

        if (action === ACTIONS.PREV) {
          onClickKembali(step);
        } else {
          onClickLanjut(step);
        }
        break;
    }
  };

  handleCompleteTour = () => {
    const { onCompletion } = this.props;
    this.setState({
      showCompletionModal: false,
      isTourRunning: false,
      mainKey: 0,
    });
    onCompletion();
  };

  handleReplayTour = () => {
    const { onRestart } = this.props;
    this.setState({
      isTourRunning: true,
      showCompletionModal: false,
      stepIndex: 0,
    });
    onRestart();
  };

  componentDidMount() {
    const { onWelcome } = this.props;
    onWelcome();
  }

  render() {
    const {
      showWelcomeModal,
      isTourRunning,
      showCompletionModal,
      stepIndex,
      mainKey,
    } = this.state;

    return (
      <div>
        <WelcomeModal
          isShowing={showWelcomeModal}
          onClose={this.handleWelcomeModalClose}
        />
        <CompletionModal
          isShowing={showCompletionModal}
          onClose={this.handleCompleteTour}
          onReplayButtonClick={this.handleReplayTour}
        />
        <Joyride
          run={isTourRunning}
          continuous
          steps={steps}
          callback={this.handleJoyrideCallback}
          spotlightPadding={0}
          disableCloseOnEsc
          disableOverlayClose
          tooltipComponent={Tooltip}
          floaterProps={{
            disableAnimation: true,
            id: 'sidebarFtue',
          }}
          stepIndex={stepIndex}
          key={mainKey}
          styles={{
            options: {
              zIndex: 2000,
              arrowColor: '#00b8ec',
            },
          }}
        />
      </div>
    );
  }
}

SidebarFtue.defaultProps = {
  onEnterStep: () => {},
  onEndStep: () => {},
  onTourStart: () => {},
  onTourEnd: () => {},
  onWelcome: () => {},
  onCompletion: () => {},
  onRestart: () => {},
  onClickLanjut: () => {},
  onClickKembali: () => {},
};

export default SidebarFtue;
